import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router, Switch, Redirect } from 'react-router-dom'
import './index.scss';
import TplIndex from './templates/TplIndex';
import Notfound from './templates/Notfound';
import ScrollToTop from './partials/ScrollToTop';

const routes = ( 
	<Router>
	<ScrollToTop />
        <Switch>   
        	<Route path="/https:slug" component={TplIndex} />   
           	<Route path="/http:slug" component={TplIndex} />
           	
           	
            <Route exact path="/" component={TplIndex} /> 
            <Route exact path="/news/" component={TplIndex} /> 
            <Route exact path="/customer-registration/" component={TplIndex} />
            <Route exact path="/account/" component={TplIndex} />
            <Route exact path="/account/details/" component={TplIndex} /> 
            <Route exact path="/account/quote-requests/" component={TplIndex} /> 
            <Route exact path="/lampshades-made-to-measure/" component={TplIndex} />  
            
            <Route path="/search/:slug" component={TplIndex} />
            <Route path="/news-category/:slug" component={TplIndex} />
            <Route path="/designer/:slug" component={TplIndex} /> 
            <Route path="/collection/:slug" component={TplIndex} /> 
            <Route path="/product-category/:slug" component={TplIndex} /> 
            <Route path="/product/:slug" component={TplIndex} />
            <Route path="/news/:slug" component={TplIndex} />  
            <Route path="/:slug" component={TplIndex} /> 
               
            <Redirect exact from='/post/' to='/' /> 
            <Redirect exact from='/page/' to='/' />
            <Redirect exact from='/search/' to='/' />        
			<Route component={Notfound} />
        </Switch>
      </Router> 
)

ReactDOM.render(routes, document.getElementById('root'));